import { useT } from "../../i18n/LanguageContext";

// Colorful pastel icons (no FontAwesome, no emojis — custom SVG)
function Icon({ kind }) {
  const map = {
    jacuzzi: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <ellipse cx="32" cy="36" rx="24" ry="18" fill="#1e3a8a" />
        <ellipse cx="32" cy="36" rx="20" ry="14" fill="#d6e2f5" />
        <circle cx="22" cy="34" r="2.5" fill="#fff" />
        <circle cx="30" cy="38" r="3" fill="#fff" />
        <circle cx="40" cy="34" r="2" fill="#fff" />
        <circle cx="36" cy="42" r="1.8" fill="#fff" />
        <circle cx="24" cy="41" r="1.5" fill="#fff" />
        <path d="M18 16c2 2 4 0 6 2M28 14c2 2 4 0 6 2M38 16c2 2 4 0 6 2" stroke="#c89033" strokeWidth="2" fill="none" strokeLinecap="round" />
      </svg>
    ),
    ac: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <circle cx="32" cy="32" r="26" fill="#d6e2f5" />
        <g stroke="#1e3a8a" strokeWidth="2.5" strokeLinecap="round">
          <path d="M32 14v36M14 32h36M19 19l26 26M45 19L19 45" />
        </g>
        <circle cx="32" cy="32" r="3" fill="#1e3a8a" />
      </svg>
    ),
    wifi: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <circle cx="32" cy="32" r="26" fill="#d6e2f5" />
        <g fill="#1e3a8a">
          <path d="M22 26h4v18h-4z" />
          <path d="M30 22h4v22h-4z" />
          <path d="M38 18h4v26h-4z" />
        </g>
      </svg>
    ),
    tv: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <rect x="10" y="16" width="44" height="30" rx="3" fill="#1e3a8a" />
        <rect x="14" y="20" width="36" height="22" rx="1" fill="#d6e2f5" />
        <rect x="24" y="48" width="16" height="3" rx="1" fill="#1e3a8a" />
      </svg>
    ),
    coffee: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <path d="M14 26h36v18a10 10 0 0 1-10 10H24a10 10 0 0 1-10-10V26z" fill="#8B5E3C" />
        <path d="M50 30h4a6 6 0 0 1 0 12h-4" stroke="#8B5E3C" strokeWidth="3" fill="none" />
        <path d="M22 12c0 4 4 4 4 8M30 10c0 4 4 4 4 8M38 12c0 4 4 4 4 8" stroke="#c89033" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      </svg>
    ),
    kitchen: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <circle cx="32" cy="32" r="26" fill="#c0492c" />
        <circle cx="32" cy="32" r="14" fill="#faf6ee" />
        <path d="M22 32h20M32 22v20" stroke="#c0492c" strokeWidth="3" strokeLinecap="round" />
      </svg>
    ),
    parking: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <rect x="8" y="8" width="48" height="48" rx="10" fill="#1e3a8a" />
        <path d="M24 18h12a8 8 0 1 1 0 16h-7v12h-5V18z" fill="#e3b25b" />
        <rect x="29" y="23" width="7" height="6" rx="2" fill="#1e3a8a" />
      </svg>
    ),
    checkout: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <circle cx="24" cy="32" r="11" fill="none" stroke="#c89033" strokeWidth="4" />
        <path d="M34 32h24M50 24l8 8-8 8" stroke="#c89033" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="24" cy="32" r="3" fill="#c89033" />
      </svg>
    ),
    pets: (
      <svg viewBox="0 0 64 64" className="w-14 h-14">
        <g fill="#c89033">
          <circle cx="20" cy="22" r="6" />
          <circle cx="44" cy="22" r="6" />
          <circle cx="10" cy="34" r="5" />
          <circle cx="54" cy="34" r="5" />
          <path d="M32 30c-9 0-16 8-16 16 0 5 4 8 8 8 3 0 5-2 8-2s5 2 8 2c4 0 8-3 8-8 0-8-7-16-16-16z" />
        </g>
      </svg>
    ),
  };
  return <div className="flex justify-center">{map[kind]}</div>;
}

export default function Comodidades() {
  const { t } = useT();
  const items = [
    { k: "jacuzzi", ...t.amenities.items.jacuzzi },
    { k: "ac", ...t.amenities.items.ac },
    { k: "wifi", ...t.amenities.items.wifi },
    { k: "tv", ...t.amenities.items.tv },
    { k: "coffee", ...t.amenities.items.coffee },
    { k: "kitchen", ...t.amenities.items.kitchen },
    { k: "parking", ...t.amenities.items.parking },
    { k: "checkout", ...t.amenities.items.checkout },
    { k: "pets", ...t.amenities.items.pets },
  ];

  return (
    <section id="comodidades" className="py-20 md:py-28" data-testid="comodidades-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal max-w-3xl">
          <p className="section-label">{t.amenities.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-[#0e1a3f] leading-[1.05]">
            {t.amenities.title1}
            <br />
            <em className="text-[#1e3a8a]">{t.amenities.title2}</em>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-14">
          {items.map((it) => (
            <article
              key={it.k}
              className="reveal card-lift bg-[#f6ecd9] p-6 rounded-2xl text-center"
              data-testid={`comodidade-${it.k}`}
            >
              <Icon kind={it.k} />
              <h3 className="font-display text-lg sm:text-xl mt-4 text-[#0e1a3f]">{it.t}</h3>
              <p className="mt-2 text-xs sm:text-sm text-[#0e1a3f]/70 leading-relaxed">{it.d}</p>
            </article>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-5 mt-10">
          <div className="reveal bg-[#f6ecd9] rounded-2xl p-7">
            <h4 className="font-display text-xl text-[#0e1a3f]">
              <span className="text-xs uppercase tracking-[0.22em] text-[#c89033] block mb-2">
                {t.amenities.rules.title}
              </span>
            </h4>
            <ul className="mt-1 space-y-2 text-sm text-[#0e1a3f]/85">
              {t.amenities.rules.items.map((it) => (
                <li key={it}>{it}</li>
              ))}
            </ul>
          </div>
          <div className="reveal bg-[#f6ecd9] rounded-2xl p-7">
            <h4 className="font-display text-xl text-[#0e1a3f]">
              <span className="text-xs uppercase tracking-[0.22em] text-[#c89033] block mb-2">
                {t.amenities.recycling.title}
              </span>
            </h4>
            <ul className="mt-1 space-y-2 text-sm text-[#0e1a3f]/85">
              {t.amenities.recycling.items.map((it, i) => {
                const dots = ["bg-blue-600", "bg-yellow-400", "bg-green-600", "bg-neutral-800"];
                return (
                  <li key={it}>
                    <span className={`inline-block w-3 h-3 rounded-full ${dots[i]} mr-2 align-middle`} />
                    {it}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
